function ascdesc(a, b) {
  if (a.created_at) {
    return new Date(b.created_at) - new Date(a.created_at);
  }

  return b.id - a.id;
}

export const SORT_METHODS = {
  invitation_sent_at_desc: {
    label: 'Mais recentes primeiro',
    value: 'invitation_sent_at_desc',
    sort: (a, b) => ascdesc(a, b),
  },
  invitation_sent_at_asc: {
    label: 'Mais antigos primeiro',
    value: 'invitation_sent_at_asc',
    sort: (a, b) => ascdesc(b, a),
  },
};

export default function sort(items = {}, order = SORT_METHODS.invitation_sent_at_desc.value) {
  return Object
    .values(items)
    .sort(SORT_METHODS[order].sort);
}

export const DENIED = 'DENIED';
export const ACCEPTED = 'ACCEPTED';

export const IDENTIFIERS = {
  [DENIED]: false,
  [ACCEPTED]: true,
};

export const TITLES = {
  [DENIED]: 'Ainda não se cadastrou',
  [ACCEPTED]: 'Já se cadastrou',
};
